import { render } from "./basic-selector.vue?vue&type=template&id=ba9e7d78&scoped=true"
import script from "./basic-selector.vue?vue&type=script&lang=js"
export * from "./basic-selector.vue?vue&type=script&lang=js"

import "./basic-selector.vue?vue&type=style&index=0&id=ba9e7d78&lang=scss"
import "./basic-selector.vue?vue&type=style&index=1&id=ba9e7d78&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba9e7d78"]])

export default __exports__